import script from "./PageProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./PageProduct.vue?vue&type=script&setup=true&lang=js"

import "./PageProduct.vue?vue&type=style&index=0&id=2937ed4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2937ed4a"]])

export default __exports__